import { PATH_ADMIN, PATH_ADMIN_KC } from './paths';
import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';
import AuthProtect from 'src/components/Auth/AuthProtect';
import DashboardAdminKCLayout from 'src/layouts/DashboardAdminKCLayout';

import AuthProtectAgreementTerms from 'src/components/Auth/AdminKC/AuthProtectAgreementTerms/AuthProtectAgreementTerms';
import AuthProtectAgreementTermsAdd from 'src/components/Auth/AdminKC/AuthProtectAgreementTerms/AuthProtectAgreementTermsAdd';
import AuthProtectAgreementTermsEdit from 'src/components/Auth/AdminKC/AuthProtectAgreementTerms/AuthProtectAgreementTermsEdit';
import AuthProtectAgreementTermsView from 'src/components/Auth/AdminKC/AuthProtectAgreementTerms/AuthProtectAgreementTermsView';

import AuthProtectRole from 'src/components/Auth/AdminKC/AuthProtectRole/AuthProtectRole';
import AuthProtectRoleAdd from 'src/components/Auth/AdminKC/AuthProtectRole/AuthProtectRoleAdd';
import AuthProtectRoleEdit from 'src/components/Auth/AdminKC/AuthProtectRole/AuthProtectRoleEdit';
import AuthProtectRoleView from 'src/components/Auth/AdminKC/AuthProtectRole/AuthProtectRoleView';

import AuthProtectDistributor from 'src/components/Auth/AdminKC/AuthProtectDistributor/AuthProtectDistributor';
import AuthProtectDistributorAdd from 'src/components/Auth/AdminKC/AuthProtectDistributor/AuthProtectDistributorAdd';
import AuthProtectDistributorEdit from 'src/components/Auth/AdminKC/AuthProtectDistributor/AuthProtectDistributorEdit';
import AuthProtectDistributorView from 'src/components/Auth/AdminKC/AuthProtectDistributor/AuthProtectDistributorView';

import AuthProtectUserMaster from 'src/components/Auth/AdminKC/AuthProtectUserMaster/AuthProtectUserMaster';
import AuthProtectUserMasterAdd from 'src/components/Auth/AdminKC/AuthProtectUserMaster/AuthProtectUserMasterAdd';
import AuthProtectUserMasterEdit from 'src/components/Auth/AdminKC/AuthProtectUserMaster/AuthProtectUserMasterEdit';
import AuthProtectUserMasterView from 'src/components/Auth/AdminKC/AuthProtectUserMaster/AuthProtectUserMasterView';

import AuthProtectRetailer from 'src/components/Auth/AdminKC/AuthProtectRetailer/AuthProtectRetailer';
import AuthProtectRetailerAdd from 'src/components/Auth/AdminKC/AuthProtectRetailer/AuthProtectRetailerAdd';
import AuthProtectRetailerEdit from 'src/components/Auth/AdminKC/AuthProtectRetailer/AuthProtectRetailerEdit';
import AuthProtectRetailerView from 'src/components/Auth/AdminKC/AuthProtectRetailer/AuthProtectRetailerView';

import AuthProtectNotifications from 'src/components/Auth/AdminKC/AuthProtectNotifications/AuthProtectNotifications';
import AuthProtectNotifApplications from 'src/components/Auth/AdminKC/AuthProtectNotifications/AuthProtectNotifApplications';

import AuthProtectBranch from 'src/components/Auth/AdminKC/AuthProtectBranch/AuthProtectBranch';
import AuthProtectBranchView from 'src/components/Auth/AdminKC/AuthProtectBranch/AuthProtectBranchView';

import AuthProtectCurrency from 'src/components/Auth/AdminKC/AuthProtectCurrency/AuthProtectCurrency';
import AuthProtectCurrencyView from 'src/components/Auth/AdminKC/AuthProtectCurrency/AuthProtectCurrencyView';
// ----------------------------------------------------------------------

const AppAdminKCRoutes = {
  path: PATH_ADMIN_KC.root,
  guard: AuthProtect,
  layout: DashboardAdminKCLayout,
  routes: [
    // GENERAL
    // ----------------------------------------------------------------------

    // DASHBOARD
    {
      exact: true,
      path: PATH_ADMIN_KC.general.dashboard,
      component: lazy(() => import('src/views/AdminKCDashboardGroup/dashboard/DashboardAppView'))
    },

    // NOTIFICATION
    {
      exact: true,
      path: PATH_ADMIN_KC.general.notifications,
      guard: AuthProtectNotifications,
      component: lazy(() => import('src/views/AdminKCDashboardGroup/notifications/Notifications'))
    },
    {
      exact: true,
      path: PATH_ADMIN_KC.general.notificationDetail.view,
      guard: AuthProtectNotifApplications,
      component: lazy(() => import('src/views/AdminKCDashboardGroup/notifications/detail/NotificationView'))
    },

    // DISTRIBUTOR
    {
      exact: true,
      path: PATH_ADMIN_KC.general.distributor,
      guard: AuthProtectDistributor,
      component: lazy(() => import('src/views/AdminKCDashboardGroup/distributor/Distributor'))
    },
    {
      exact: true,
      path: PATH_ADMIN_KC.general.addDistributor,
      guard: AuthProtectDistributorAdd,
      component: lazy(() => import('src/views/AdminKCDashboardGroup/distributor/AddDistributorNew'))
    },
    {
      exact: true,
      path: PATH_ADMIN_KC.general.distributorDetails.view,
      guard: AuthProtectDistributorView,
      component: lazy(() => import('src/views/AdminKCDashboardGroup/distributor/details/DistributorView'))
    },
    {
      exact: true,
      path: PATH_ADMIN_KC.general.distributorDetails.moduleSetting,
      guard: AuthProtectDistributorEdit,
      component: lazy(() => import('src/views/AdminKCDashboardGroup/distributor/details/DistributorModuleSetting'))
    },
    {
      exact: true,
      path: PATH_ADMIN_KC.general.distributorDetails.subdistributorSetting,
      guard: AuthProtectDistributorEdit,
      component: lazy(() => import('src/views/AdminKCDashboardGroup/distributor/details/DistributorSubdistributorSetting'))
    },

    // RETAILER
    {
      exact: true,
      path: PATH_ADMIN_KC.general.retailer,
      guard: AuthProtectRetailer,
      component: lazy(() => import('src/views/AdminKCDashboardGroup/retailer/Retailer'))
    },
    {
      exact: true,
      path: PATH_ADMIN_KC.general.retailerDetails.view,
      guard: AuthProtectRetailerView,
      component: lazy(() => import('src/views/AdminKCDashboardGroup/retailer/details/RetailerView'))
    },
    {
      exact: true,
      path: PATH_ADMIN_KC.general.addRetailer,
      guard: AuthProtectRetailerAdd,
      component: lazy(() => import('src/views/AdminKCDashboardGroup/retailer/AddRetailer'))
    },
    {
      exact: true,
      path: PATH_ADMIN_KC.general.editRetailer,
      guard: AuthProtectRetailerEdit,
      component: lazy(() => import('src/views/AdminKCDashboardGroup/retailer/EditRetailer'))
    },

    // BRANCH
    {
      exact: true,
      path: PATH_ADMIN_KC.general.branch,
      guard: AuthProtectBranch,
      component: lazy(() => import('src/views/AdminKCDashboardGroup/branch/Branch'))
    },
    {
      exact: true,
      path: PATH_ADMIN_KC.general.branchDetails.view,
      guard: AuthProtectBranchView,
      component: lazy(() => import('src/views/AdminKCDashboardGroup/branch/details/BranchView'))
    },

    // AGREEMENT TERMS
    {
      exact: true,
      path: PATH_ADMIN_KC.general.agreementTerms,
      guard: AuthProtectAgreementTerms,
      component: lazy(() => import('src/views/AdminKCDashboardGroup/agreementTerms/AgreementTerms'))
    },
    {
      exact: true,
      path: PATH_ADMIN_KC.general.addAgreementTerms,
      guard: AuthProtectAgreementTermsAdd,
      component: lazy(() => import('src/views/AdminKCDashboardGroup/agreementTerms/AddAgreementTerms'))
    },
    {
      exact: true,
      path: PATH_ADMIN_KC.general.agreementTermsDetails.view,
      guard: AuthProtectAgreementTermsView,
      component: lazy(() => import('src/views/AdminKCDashboardGroup/agreementTerms/details/ViewAgreementTerms'))
    },
    {
      exact: true,
      path: PATH_ADMIN_KC.general.agreementTermsDetails.edit,
      guard: AuthProtectAgreementTermsEdit,
      component: lazy(() => import('src/views/AdminKCDashboardGroup/agreementTerms/details/EditAgreementTerms'))
    },

    // USER MASTER
    {
      exact: true,
      path: PATH_ADMIN_KC.general.userMaster,
      guard: AuthProtectUserMaster,
      component: lazy(() => import('src/views/AdminKCDashboardGroup/user-master/User'))
    },
    {
      exact: true,
      path: PATH_ADMIN_KC.general.addUserMaster,
      guard: AuthProtectUserMasterAdd,
      component: lazy(() => import('src/views/AdminKCDashboardGroup/user-master/AddUser'))
    },
    {
      exact: true,
      path: PATH_ADMIN_KC.general.userMasterDetails.view,
      guard: AuthProtectUserMasterView,
      component: lazy(() => import('src/views/AdminKCDashboardGroup/user-master/ViewUser'))
    },
    {
      exact: true,
      path: PATH_ADMIN_KC.general.userMasterDetails.emailNotificationSetting,
      guard: AuthProtectUserMasterEdit,
      component: lazy(() => import('src/views/AdminKCDashboardGroup/user-master/EmailNotificationSetting'))
    },

    // ROLE
    {
      exact: true,
      path: PATH_ADMIN_KC.general.role,
      guard: AuthProtectRole,
      component: lazy(() => import('src/views/AdminKCDashboardGroup/role/Role'))
    },
    {
      exact: true,
      path: PATH_ADMIN_KC.general.addRole,
      guard: AuthProtectRoleAdd,
      component: lazy(() => import('src/views/AdminKCDashboardGroup/role/AddRole'))
    },
    {
      exact: true,
      path: PATH_ADMIN_KC.general.roleDetails.view,
      guard: AuthProtectRoleView,
      component: lazy(() => import('src/views/AdminKCDashboardGroup/role/RoleView'))
    },

    // CURRENCY
    {
      exact: true,
      path: PATH_ADMIN_KC.general.currency,
      guard: AuthProtectCurrency,
      component: lazy(() => import('src/views/AdminKCDashboardGroup/currency/Currency'))
    },
    {
      exact: true,
      path: PATH_ADMIN_KC.general.addCurrency,
      guard: AuthProtectCurrencyView,
      component: lazy(() => import('src/views/AdminKCDashboardGroup/currency/AddCurrency'))
    },
    {
      exact: true,
      path: PATH_ADMIN_KC.general.currencyDetails.view,
      guard: AuthProtectCurrencyView,
      component: lazy(() => import('src/views/AdminKCDashboardGroup/currency/details/CurrencyView'))
    },
    {
      exact: true,
      path: PATH_ADMIN_KC.general.currencyDetails.edit,
      guard: AuthProtectCurrencyView,
      component: lazy(() => import('src/views/AdminKCDashboardGroup/currency/details/CurrencyEdit'))
    }
  ]
}

export default AppAdminKCRoutes